// extracted by mini-css-extract-plugin
export var sbShowMain = "findOutMore-module--sb-show-main--7BtWT";
export var icon = "findOutMore-module--icon--3ub5A";
export var primary = "findOutMore-module--primary--1Xo6m";
export var secondary = "findOutMore-module--secondary--33Lpw";
export var link = "findOutMore-module--link--3JYAp";